import { PARTNER_REDIRECT_PATH } from '../config';
import { type ProviderOfferData } from '../model/types';

export const buildPartnerRedirectUrl = (offer: ProviderOfferData): string => {
  const params = new URLSearchParams({
    operatorId: String(offer.operatorId),
    partnerRedirectUrl: offer.redirectUrl ?? '',
  });
  return `${PARTNER_REDIRECT_PATH}?${params.toString()}`;
};
